import React from 'react';
import { Card } from './ui/card';

export const MenuCategoryCard = ({ title, image, icon: Icon, onClick }) => {
  return (
    <Card 
      className="bg-[#D4A85F] border-none shadow-xl overflow-hidden cursor-pointer group transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl"
      onClick={onClick}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
      </div>
      <div className="p-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-2">
          {Icon && <Icon className="text-black" size={24} />}
          <h3 className="text-2xl font-bold text-black">{title}</h3>
        </div>
        <p className="text-sm text-gray-800">Cliquez pour voir le menu</p>
      </div>
    </Card>
  );
};
